<h1>Login</h1>
<div class="wrapper-actions">
  <button (click)="login()" class="btn primary" type="button">Login</button>
  <button (click)="logout()" class="btn primary" type="button">logout</button>
  <button (click)="refreshIdToken()" class="btn primary" type="button">RefreshIdToken</button>
  <button (click)="setExpiresUserAuth()" class="btn primary" type="button">set user expires to epoch</button>
</div>

<h3>User token</h3>

<div class="wrapper-button-controls">
  <ui-button (clicked)="copyUserToken()">Copy raw token</ui-button>
  <ui-button (clicked)="copyUserTokenForHttpConfig()">Copy token for http config</ui-button>
</div>

<pre>{{ userToken() | json }}</pre>

@if (customers()) {
  <ui-customer-autocomplete
    (selectChange)="customerSelected($event)"
    [customer]="customer()"
    [customers]="customers() ?? []"
  ></ui-customer-autocomplete>
}

<h3>shop token</h3>

<h3>Other results</h3>
<pre>{{ json | json }}</pre>
